import Vue from 'vue';
import Vuex from 'vuex';
import service from '@/service';
import { CONTEXT } from '@/const';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    /**
     * @type {LoginInfo}
     */
    loginInfo: {},
    /**
     * @type {AppPolicy}
     */
    appPolicy: {},
    /**
     * @type {CookieStatement}
     */
    cookieStatement: {},
  },
  getters: {},
  mutations: {
    setLoginInfo(state, payload) {
      state.loginInfo = payload;
    },
    setAppPolicy(state, payload) {
      state.appPolicy = payload;
    },
    setCookieStatement(state, payload) {
      state.cookieStatement = payload;
    },
  },
  actions: {
    async getLoginInfo({ commit }) {
      try {
        const loginInfo = await service.getLoginInfo();
        commit('setLoginInfo', loginInfo);
      } catch {
        // 接口报错时，也要触发响应式变化
        commit('setLoginInfo', {
          employeeLogoMobile: '',
          logoMobile: '',
          title: '',
        });
      }
    },
    async getAppPolicy({ commit }) {
      try {
        const appPolicy = await service.getAppPolicy();
        commit('setAppPolicy', appPolicy);
        const { enableUpgradeHwId } = appPolicy;
        if (enableUpgradeHwId === 1) {
          location.pathname = `${CONTEXT.uniportal}/hwid-login.html`;
        }
      } catch {
        commit('setAppPolicy', {
          registrationType: '',
          loginType: [],
          otherSettings: {
            showHelpGuide: 0,
            showPrivacyStatement: 0,
          },
          enableUpgradeHwId: 0,
          enablehwidLogin: 0,
          hwidThirdMibilePolicy: '',
          hwLoginAddress: '',
          hwLoginAddressMobile: '',
          status: 0,
          thirdPartyAllow: false,
          thirdpartyType: 0,
          hideSection: '',
          whiteTenantID: false,
        });
      }
    },
    async getCookieStatement({ commit }) {
      try {
        const cookieStatement = await service.getCookieStatement();
        commit('setCookieStatement', cookieStatement || { visible: true });
      } catch {
        commit('setCookieStatement', { visible: true });
      }
    },
  },
  modules: {},
});
